// extracted by mini-css-extract-plugin
module.exports = {"check-item":"CheckItem_check-item__b_AJA"};